import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { Card, CardContent, FormFlex, Icon, IconButton, Typography, } from '../../legacy/components';
import { styled } from '../../legacy/utils';
import { DocumentFilenameChip } from './DocumentFilenameChip';
export const DocumentCard = memo(({ onDeleteClick, isEdit, disabled, caption, title, files, }) => {
    const onDeleteClickWrapper = useCallback(() => {
        if (onDeleteClick) {
            onDeleteClick();
        }
    }, [onDeleteClick]);
    return (_jsx(CardStyled, { children: _jsxs(CardContentStyled, { children: [_jsxs(FormFlex, { rowGap: 0, columnGap: 0, align: "center", justifyContent: "space-between", flexWrap: "nowrap", children: [_jsxs(FormFlex, { rowGap: 0, columnGap: 2, align: "center", children: [_jsx(Icon, { fontSize: "medium", variant: "document-save", color: "primary" }), _jsxs(FormFlex, { rowGap: 0, columnGap: 0, flexDirection: "column", align: "flex-start", flexGrow: 1, children: [_jsx(Typography, { marginBottom: "0px", fontSize: "0.5rem", color: "primary", fontWeight: "700", children: title }), caption && (_jsx(Typography, { color: "primary", variant: "caption", fontSize: "small", children: caption }))] })] }), isEdit && (_jsx(IconButton, { onClick: onDeleteClickWrapper, variant: "bin", size: "small", type: "button", color: "error", disabled: disabled }))] }), _jsx(DocumentFilenameChip, { files: files })] }) }));
});
DocumentCard.displayName = 'DocumentCard';
const CardStyled = styled(Card)(({ theme }) => ({
    border: `0.5px solid ${theme.palette.groupPrimary.lightBlue}`,
}));
const CardContentStyled = styled(CardContent)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2),
}));
